<template>
  <div>
    <b-card
      id="coordinateCard"
      v-if="showCoordinateCard"
      no-body
      class="menu-bg-blue-transparent"
      style="overflow-x: hidden"
    >
      <b-row>
        <!-- Coordinates Column -->
        <b-col>
          <b-row class="px-2 text-center" align-v="center">
            <b-col>
              <div class="smCoords">
                {{ this.format ? this.googleCoords : this.qgisCoords }}
              </div>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col>
              {{ this.format ? this.googleCoordsLabel : this.qgisCoordsLabel }}
            </b-col>
          </b-row>
        </b-col>
        <!-- Window Close and Format Swap buttons -->
        <b-col class="fontAwesomeAttr">
          <fa
            :icon="['fas', 'window-close']"
            class="float-right m-1"
            style="cursor: pointer"
            title="Close"
            @click="$emit('showCoordCard', false)"
            size="sm"
          />
          <fa
            :icon="['fas', 'exchange-alt']"
            class="float-right m-1"
            style="cursor: pointer"
            title="Swap Format"
            @click="swapLongLat()"
          />
          <fa
            :icon="['fas', clipboardIcon]"
            class="float-right m-1"
            style="cursor: pointer"
            title="Copy Coordinates"
            @click="copyCoordinates()"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<style scoped>
.fontAwesomeAttr {
  display: inline-block;
}
.smCoords {
  font-size: 13px;
}
</style>

<script>
export default {
  name: 'MMP_DisplayClickCoords',
  props: ['googleCoords', 'qgisCoords', 'showCoordinateCard'],
  data() {
    return {
      clipboardIcon: 'clipboard',
      format: false,
      googleCoordsLabel: 'Lat, Long (Google)',
      qgisCoordsLabel: 'Long, Lat (QGIS)'
    }
  },
  methods: {
    copyCoordinates() {
      navigator.clipboard.writeText(
        this.format ? this.googleCoords : this.qgisCoords
      )
      this.clipboardIcon = 'clipboard-check'
    },
    // REFACTOR SUGGESTION -- this fn is never used.
    showCoords(long, lat) {
      this.$emit('showCoords', {
        google: lat + ',' + long,
        qgis: long + ',' + lat
      })
      this.clipboardIcon = 'clipboard'
    },
    swapLongLat() {
      this.format = !this.format
      this.clipboardIcon = 'clipboard'
    }
  }
}
</script>
